module.exports = {
    UPDATE_AUTH: 'UPDATE_AUTH',
    UPDATE_MODAL: 'UPDATE_MODAL',
    UPDATE_BREADCRUMBS: 'UPDATE_BREADCRUMBS',
    UPDATE_TOASTER_CONFIG: 'UPDATE_TOASTER_CONFIG',
    UPDATE_PROFILE_Image: 'UPDATE_PROFILE_Image',
    NOTIFICATION_COUNT : "NOTIFICATION_COUNT"
  };
  